import { NewMap } from "@synergy/maps";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { io } from "socket.io-client";
import styled from "styled-components";
import { useAuthContext } from "../../contexts/AuthContext";
import { useGlobalFilterContext } from "../../contexts/GlobalFilterProvider";
import { usePageContentContext } from "../../contexts/PageContentProvider";
import logger from "../../server/server";
import { PageContent } from "../../styles/global/Pages.styled";
import Theme from "../../styles/Theme/Theme";
import { REACT_APP_MAPS_API_KEY, websocketPort } from "../../utils/config/configs";
import Spinner from "../Global/Atomics/Spinner";
import { MapCreateIncidentModal } from "../Global/Molecules/Map/MapCreateIncidentModal/MapCreateIncidentModal";
import { CreateIncidentsOverlay } from "../Global/Molecules/Map/Overlay/CreateIncidentsOverlay";
import { WidgetsOverlay } from "../Global/Molecules/Map/Overlay/WidgetOverlay";
import MapDrawer from '../Global/Organism/Maps/MapDrawer';

const socket = io(websocketPort);

export const Map = ({ headerheight }) => {
  const { t } = useTranslation();
  const { user, tenant } = useAuthContext();
  const { entity, subEntity, isToApplyFilters,
    mapItemsIncidentsData, mapItemsServicesData, isFetchingMapServicesData, selectedLayer,
    classes, prioritiesSelected, refetchMapItemsIncidents, mapPOISelected, setMapPOISelected } = useGlobalFilterContext();
  const navigate = useNavigate();
  const { handlePagePathChange } = usePageContentContext();

  const [mapConfigurations, setMapConfigurations] = useState(null);
  const [mapPois, setMapPois] = useState(null);
  const [copyMapPois, setCopyMapPois] = useState(null);
  const [selectedPOI, setSelectedPOI] = useState(null);
  const [selectedCluster, setSelectedCluster] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);

  //Create Incidents Mode
  const [rightClickCoordinates, setRightClickCoordinates] = useState(null);
  const [createIncidentModal, setCreateIncidentModal] = useState(false);
  const [isOnCreateIncidentMode, setIsOnCreateIncidentMode] = useState(false);
  const [mapClickCoordinates, setMapClickCoordinates] = useState(null);

  const novaCampolideBoundary = {
    "coordinates": [
      [
        { lat: 38.7400, lng: -9.1710 }, // NW (noroeste)
        { lat: 38.7400, lng: -9.1500 }, // NE (nordeste)
        { lat: 38.7270, lng: -9.1500 }, // SE (sudeste)
        { lat: 38.7270, lng: -9.1710 }, // SW (sudoeste)
      ],
      [
        {
          "lat": 38.73396671694971,
          "lng": -9.162425994873047
        },
        {
          "lat": 38.73398763977575,
          "lng": -9.16235625743866
        },
        {
          "lat": 38.73393742498297,
          "lng": -9.162302613258362
        },
        {
          "lat": 38.73400856259565,
          "lng": -9.16208267211914
        },
        {
          "lat": 38.73410062293043,
          "lng": -9.16210412979126
        },
        {
          "lat": 38.73435169596769,
          "lng": -9.161884188652039
        },
        {
          "lat": 38.734619506234694,
          "lng": -9.161036610603333
        },
        {
          "lat": 38.734531631101525,
          "lng": -9.160645008087156
        },
        {
          "lat": 38.7346739050725,
          "lng": -9.160210490226746
        },
        {
          "lat": 38.734569291886125,
          "lng": -9.160146117210388
        },
        {
          "lat": 38.73456510735547,
          "lng": -9.160065650939941
        },
        {
          "lat": 38.73437261868096,
          "lng": -9.160065650939941
        },
        {
          "lat": 38.733230229568626,
          "lng": -9.159471541643143
        },
        {
          "lat": 38.73320093729986,
          "lng": -9.159550666809082
        },
        {
          "lat": 38.73313398349759,
          "lng": -9.159497022628782
        },
        {
          "lat": 38.732897552381246,
          "lng": -9.159269034862518
        },
        {
          "lat": 38.732569058292306,
          "lng": -9.159035682678223
        },
        {
          "lat": 38.73244561107858,
          "lng": -9.158976674079895
        },
        {
          "lat": 38.732317978989215,
          "lng": -9.159405827522278
        },
        {
          "lat": 38.73172793915319,
          "lng": -9.159078598022461
        },
        {
          "lat": 38.73116300282835,
          "lng": -9.159899353981018
        },
        {
          "lat": 38.731313652951805,
          "lng": -9.160189032554626
        },
        {
          "lat": 38.73186603401973,
          "lng": -9.160457253456116
        },
        {
          "lat": 38.731903696209734,
          "lng": -9.160655736923218
        },
        {
          "lat": 38.732606720111654,
          "lng": -9.16105806827545
        },
        {
          "lat": 38.732523027152816,
          "lng": -9.161310195922852
        },
        {
          "lat": 38.732535581102866,
          "lng": -9.161621332168579
        },
        {
          "lat": 38.7325648736445,
          "lng": -9.161701798439026
        },
        {
          "lat": 38.73280339817898,
          "lng": -9.162039756774902
        },
        {
          "lat": 38.73294986021777,
          "lng": -9.16211485862732
        },
        {
          "lat": 38.732945675592255,
          "lng": -9.162071943283081
        },
        {
          "lat": 38.733493859446945,
          "lng": -9.162318706512451
        },
        {
          "lat": 38.73359428962085,
          "lng": -9.162372350692747
        },
        {
          "lat": 38.73396671694971,
          "lng": -9.162425994873047
        }
      ].slice().reverse()
    ],
    "strokeColor": "#afadad",
    "fillColor": "#afadad",
    "fillOpacity": 0.7,
  };

  useEffect(() => {
    if (mapItemsServicesData && mapItemsIncidentsData && (subEntity || entity)) {
      const pois = selectedLayer === 'Services' ?
        mapItemsServicesData?.filter(item => item.latitude && item.latitude !== "0" && item.longitude && item.longitude !== "0") :
        mapItemsIncidentsData?.filter(item => item.latitude && item.latitude !== "0" && item.longitude && item.longitude !== "0");
      setMapPois(pois);
      setCopyMapPois(pois);
    }
  }, [mapItemsServicesData, mapItemsIncidentsData]);

  useEffect(() => {
    if (!isToApplyFilters && (subEntity || entity)) {
      if (selectedLayer === 'Incidents' && mapItemsIncidentsData) {
        const data = mapItemsIncidentsData?.filter(item => item.latitude && item.latitude !== "0" && item.longitude && item.longitude !== "0");
        setMapPois(data);
        setCopyMapPois(data.filter(item => classes?.map(c => c.value)?.includes(item.class) && prioritiesSelected?.map(p => p.value)?.includes(item.priority)));
      }
      if (selectedLayer === 'Services' && mapItemsServicesData) {
        const data = mapItemsServicesData?.filter(item => item.latitude && item.latitude !== "0" && item.longitude && item.longitude !== "0");
        setMapPois(data);
        // setCopyMapPois(data.filter(item => classes?.map(c => c.value)?.includes(item.class)));
        setCopyMapPois(data);
      }
    }
  }, [selectedLayer]);

  useEffect(() => {
    if (selectedPOI) {
      showDrawer();
    }
  }, [selectedPOI]);

  useEffect(() => {
    if (rightClickCoordinates) {
      setCreateIncidentModal(true);
    }
  }, [rightClickCoordinates]);

  useEffect(() => {
    socket.on("manageIncident", (text) => {
      let incs = JSON.parse(text);
      console.log('Novo incidente', incs);
      refetchMapItemsIncidents();
    });
  }, [])

  const handleMarkerClick = (markerId, event) => {
    try {
      const clickedMarker = mapPois?.find(
        (marker) => marker.id === markerId
      );
      setSelectedPOI(clickedMarker);

      // Calcula origem do clique no mapa
      if (event) {
        const boundingRect = event.target.getBoundingClientRect();
        const x = event.clientX - boundingRect.left;
        const y = event.clientY - boundingRect.top;

        setTransitionOrigin(`${(x / boundingRect.width) * 100}% ${(y / boundingRect.height) * 100}%`);
      }
    } catch (error) {
      console.error("(MapComponent page) Error in handling Marker Click:", error);
      logger.error("(MapComponent page) User : " + user + " Tenant: " + tenant + ", Error in handling Marker Click: ", error);
    }
  };

  const showDrawer = () => {
    console.log('clicked');
    setOpenDrawer(true);
    logger.info('User: ' + user + ' Tenant: ' + tenant + ', Drawer opened!')
  };

  const onCloseDrawer = () => {
    setOpenDrawer(false);
    setSelectedPOI(null);
    logger.info('User: ' + user + ' Tenant: ' + tenant + ', Drawer closed!')
  };

  const filterPOIs = (filteredProperties, type) => {
    var filteredPOIs;
    if (type === 'priority') {
      const filteredByPriority = mapPois?.filter(poi => filteredProperties?.includes(poi.priority)) ?? [];
      const filteredByClass = filteredByPriority?.filter(poi => classes.map(c => c.value).includes(poi.class)) ?? [];
      filteredPOIs = filteredByClass;
    }
    else {
      if (selectedLayer === 'Incidents') {
        const filteredByPriority = mapPois?.filter(poi => filteredProperties?.includes(poi.class)) ?? [];
        const filteredByClass = filteredByPriority?.filter(poi => prioritiesSelected.map(p => p.value).includes(poi.priority));
        filteredPOIs = filteredByClass;
      } else {
        filteredPOIs = mapPois?.filter(poi => filteredProperties?.includes(poi.class)) ?? [];
      }
    }
    setCopyMapPois(filteredPOIs);
  };

  const redirectToDigitalTwin = (value) => {
    if (value.id) {
      navigate(`/registry/item/${value.id}/overview/digital-twin`);
      handlePagePathChange(`/registry/item/${value.id}/overview/digital-twin`);
    };
  };

  /**
   * Normalizes the coordinates object by extracting the latitude and longitude values.
   * If the coordinates object has a 'poi' property, it will use the 'poi' property's latitude and longitude.
   * Otherwise, it will use the 'lat' and 'lng' properties directly.
   *
   * @param {Object} coordinates - The coordinates object to normalize.
   * @param {Object} coordinates.poi - The 'poi' property of the coordinates object.
   * @param {number} coordinates.poi.latitude - The latitude value of the 'poi' property.
   * @param {number} coordinates.poi.longitude - The longitude value of the 'poi' property.
   * @param {number} coordinates.lat - The latitude value.
   * @param {number} coordinates.lng - The longitude value.
   * @returns {Object} - The normalized coordinates object with 'lat' and 'lng' properties.
   */
  const normalizeCoordinates = (coordinates) => {
    if (!coordinates) return null;

    if (coordinates.poi) {
      return { lat: coordinates.poi.latitude, lng: coordinates.poi.longitude };
    }
    return { lat: coordinates.lat, lng: coordinates.lng };
  };

  const addNewIncidentToMap = (incident) => {
    if (!incident) return;

    if (selectedLayer === 'Incidents') {
      setMapPois([...mapPois, incident]);
      setCopyMapPois([...copyMapPois, incident]);
    }
  };

  return (
    <PageContent style={{ height: "100%", overflow: 'hidden' }}>
      <MapWrapper $marginTop={headerheight} >
        {!isFetchingMapServicesData ? (
          <>
            {/* <SpinnerMap id="spinnerMap" className={isFetchingMapServicesData ? 'is-loading' : ''}><Spinner stroke="green-4" size='72px' /></SpinnerMap> */}

            <MapContainer height={isOnCreateIncidentMode ? 'calc(100% - 78px)' : null}>
              <NewMap
                apiKey={REACT_APP_MAPS_API_KEY}
                configurations={defaultMapConfigurations}
                pois={copyMapPois}
                onMarkerClick={(id, event) => handleMarkerClick(id, event)}
                onRightClickFucntion={selectedLayer === 'Services' ?
                  {
                    "inPOI": [
                      {
                        label: t("button.digital_twin"),
                        function: (value) => redirectToDigitalTwin(value.poi),
                      }
                    ]
                  } : null}
                onClusterClick={(cluster) => { setSelectedCluster(cluster); showDrawer(); }}
                onMapClickFunction={isOnCreateIncidentMode ? (coordenates) => { setMapClickCoordinates(coordenates) } : null}
                tooltipFields={
                  selectedLayer === 'Incidents' ?
                    {
                      gridColumns: 2,
                      fields: [
                        {
                          fieldName: t("input.incident_number"),
                          keyName: "name"
                        },
                        {
                          fieldName: t("input.location"),
                          keyName: "serviceName"
                        },
                        {
                          fieldName: t("input.service_class"),
                          keyName: "class"
                        },
                        {
                          fieldName: t("input.last_update"),
                          keyName: "lastUpdate",
                          type: "date"
                        }
                      ],
                    }
                    :
                    null
                }
                mapPOISelected={mapPOISelected}
                setMapPOISelected={setMapPOISelected}
                createPolygon={novaCampolideBoundary}
              />
            </MapContainer>
          </>
        ) : (
          <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <Spinner stroke="green-4" />
          </div>
        )}
      </MapWrapper>

      {/* {metricLegend && <ChartLegendComponent data={metricLegend} wrapperBackgroundColor="white" />} */}

      <MapDrawer
        onCloseDrawer={onCloseDrawer}
        openDrawer={openDrawer}
        selectedCluster={selectedCluster}
        selectedLayer={selectedLayer}
        selectedPOI={selectedPOI}
        setSelectedPOI={setSelectedPOI}
        redirectToDigitalTwin={redirectToDigitalTwin}
        addNewIncidentToMap={addNewIncidentToMap}
      />

      <Overlay padding={isOnCreateIncidentMode ? '0' : `${Theme.spacing["s07"]} ${Theme.spacing["s06"]}`}>
        {isOnCreateIncidentMode ? <CreateIncidentsOverlay close={() => { setMapClickCoordinates(null); setIsOnCreateIncidentMode(false) }}
          mapClickCoordinates={mapClickCoordinates} addNewIncidentToMap={addNewIncidentToMap} /> : null}

        {(entity || subEntity) && !isOnCreateIncidentMode ? <WidgetsOverlay selectedPOI={selectedPOI} selectedLayer={selectedLayer} mapPois={mapPois} copyMapPois={copyMapPois}
          subEntity={subEntity} isToApplyFilters={isToApplyFilters}
          filterPOIs={filterPOIs}
          openClusterDrawer={() => { setSelectedCluster({ 'coordenates': copyMapPois }); showDrawer() }}
          setIsOnCreateIncidentMode={() => setIsOnCreateIncidentMode(true)} /> : null}
      </Overlay>

      <MapCreateIncidentModal isCreateIncidentModalOpen={createIncidentModal} setCreateIncidentModal={setCreateIncidentModal}
        mapClickCoordinates={normalizeCoordinates(rightClickCoordinates)}
        selectedPOI={rightClickCoordinates?.poi} addNewIncidentToMap={addNewIncidentToMap}
      />
    </PageContent>
  );
}

//#region  Styled Components
const MapWrapper = styled.div`
  height: ${(props) => props.$marginTop ? "calc(100% - " + props.$marginTop + ")" : "100%"};
  margin-top: ${(props) => (props.$marginTop ? props.$marginTop : "0")};
  padding: 0;
  margin-left: ${(props) => (props.$marginLeft ? props.$marginLeft : "0")};
  width: -webkit-fill-available;
  position: absolute;
`;

const MapContainer = styled.div`
  position: absolute;
  width: 100%;
  //Necessary to calculate the height of the map for isOnCreateIncidentMode
  height: ${(props) => props.height ? props.height : "100%"};
`;

// Styling for the overlay
const Overlay = styled.div`
  padding: ${(props) => props.padding ? props.padding : null};
`;
//#endregion

const defaultMapConfigurations = {
  "heading": 0,
  "hide": [
    "attraction",
    "sports_complex",
    "place_of_worship",
    "business",
    "government",
    "medical",
    "park",
    "school"
  ],
  "mapId": "15fb961c1d0a757",
  "showGTFSRealTime": false,
  "showPOIS": true,
  "showTraffic": false,
  "showTransit": false,
  "showPolygon": false,
  "showEvents": false,
  "styles": "default",
  "tilt": 0,
  "zoom": 17.5,
  "lat": 38.73319368379715,
  "lng": -9.161331228834879,
  "bounds": {
    north: 38.7400,
    south: 38.7270,
    east: -9.1500,
    west: -9.1710
  },
  "hrefLink": "/home/register/registerDetail/",
  "poiType": "pois-color-by-family",
  "showLegend": false,
  "legendArray": [],
  "legendDetail": true,
  "hideEventsInfo": false,
  "circleRadius": null,
  "disableDefaultUI": true,
  mapTypeId: 'satellite',
};